import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, FlutterIcon, HealthcareIcon, ReactIcon} from "../../../app-constants";
import {Link} from 'gatsby';

const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android app development',
        description: (
            <>
                Our {' '}
                <Link to="/android-app-development" rel="noopener" aria-label="TekRevol">
                    Android app development services
                </Link> {' '}
                encompass a smooth process that begins with a profound understanding of your objectives. We employ industry-standard tools like Android Studio, Kotlin, and Java to craft apps that cater to the diverse user base. From conceptualization to execution, our team ensures that the app not only meets your requirements but also stands out in terms of performance, design, and user experience.
            </>
        ),
    },
    {
        icon: IphoneIcon,
        title: 'Iphone app development',
        description: (
            <>
                With  {' '}
                <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
                    iPhone app development
                </Link> {' '}
               , we delve into Apple's ecosystem using Xcode, Swift, and Objective-C to build applications that resonate with iOS users. Our developers meticulously code and design to align with Apple's design guidelines, ensuring a seamless experience. Through thorough testing, we ensure your app is ready for launch and offers optimal functionality.      </>
        ),
    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: (
            <>
                TekRevol's {' '}
                <Link to="/game-development" rel="noopener" aria-label="TekRevol">
                    game app development
                </Link> {' '}
                expertise combines creativity and technical prowess. We utilize tools like Unity and Unreal Engine to create captivating gameplay and stunning visuals. Our team incorporates game mechanics, graphics, and immersive storytelling to develop games that engage users across platforms.
            </>
        ),
    },
    {
        icon: FlutterIcon,
        title: 'Flutter app development',
        description: "Flutter's cross-platform compatibility streamlines development, and we leverage it alongside tools like Dart and Flutter Inspector. This enables us to build apps that function seamlessly on both Android and iOS devices. The result is a consistent user experience across platforms without compromising quality or performance.",
    },
    {
        icon: HealthcareIcon,
        title: 'Healthcare app development',
        description: (
            <>
                In {' '}
                <Link to="/healthcare-app-development" rel="noopener" aria-label="TekRevol">
                    healthcare app development
                </Link> {' '}
                , we utilize tools like HIPAA-compliant APIs, FHIR, and HL7 standards to ensure the highest levels of security and data privacy. We design user-friendly interfaces and integrate features like appointment scheduling, remote consultations, and patient records management. This aids medical professionals in delivering efficient and personalized care to patients.
            </>
        ),
    },
    {
        icon: ReactIcon,
        title: 'React Native app development',
        description: 'TekRevol harnesses the capabilities of React Native to create resilient mobile apps compatible with both Android and iOS platforms, guaranteeing extensive features and flawless execution. Our proficient team actively develops applications that not only fulfill your individual needs but also consistently deliver a top-tier user experience across a variety of devices and operating systems.',
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>Fueling Digital Progress with TekRevol’s Mobile App Development Services in Boston</h2>
                        <p className="impro_para">When it comes to the success of your app, you should settle for nothing but the finest. TekRevol is one of the trusted mobile app development companies in Boston which possesses a team of elite app developers who are enthusiastic about transforming your ideas into reality.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;